<template>
  <div class="slide" id="meet-ask" v-show="isVisibleSlide('meet-ask')">
    <div class="container">
      <h2>Thanks so much for leaving your message.</h2>
      <p>Your MP is one of our key targets right now - we think they could be persuaded to support the campaign once they understand how important it is to their constituents.</p>
      <p>
        <strong>So, {{ $store.state.user.firstname }}, would you consider setting up a meeting with your MP and telling them your story in person?</strong>
      </p>
      <p>Face to face meetings can be one of the most effective ways to get MPs on board.</p>
      <div class="button_wrap">
        <button @click="gotoSlide('meet-your-mp'), analytics('meet_ask', 'yes')" class="pink">Yes</button>
        <button @click="gotoSlide('will-share'), analytics('meet_ask', 'no')" class="grey">No</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Thanks",
  props: ["gotoSlide", "isVisibleSlide", "analytics"]
};
</script>

